import ajax from "@/lib/ajax";
import { listAgent, listAgentGroup } from "@/views/ticket/service";
import { formatUnixTime } from "@/lib/format/time";

async function getMap(p) {
    const { list } = await p;
    const map = {};
    list.forEach(({ id, name }) => {
        map[id] = name;
    });
    return map;
}

export async function getTicketAgentData(query = {}) {
    let result = await ajax.get("/ticket/performance/log/list", { ...query });
    let { list } = result;
    let ids = [];

    list.forEach(({ agent_id }) => {
        ids.push(agent_id);
    });

    ids = Array.from(new Set(ids.map(({ id } = {}) => id).filter(x => x)));

    const [groupMap, agentMap] = await Promise.all([getMap(listAgentGroup()), getMap(listAgent({ ids }))]);

    result.list = list.map(value => {
        return {
            ...value,
            group_name: groupMap[value.group_id] || "--",
            agent_name: agentMap[value.agent_id] || "--",
            idate: formatUnixTime(value.idate)
        };
    });

    return result;
}
